module.exports = __webpack_public_path__ + "static/media/viber.c4a3c0a1.svg";